import React, { useState, useContext } from 'react';
import envConfig from '@nile/home/src/Config/env';
import { Button } from '@superops/ui-design-system';
import ReportsContext from '@nile/reports/src/modules/home/contexts/Reports';
import { SVGIcon } from '@superops/super-icons';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
  getTranslatedText,
  getHeaderValue,
  toast,
  useActivityTracker
} from '@nile/components';
import { downloadHack as downloadHackHelper } from '@nile/components/src/Utils/helpers';

function DownloadCell(props) {
  const reportsContext = useContext(ReportsContext);
  const { cell, intl } = props;
  const meta = cell?.row?.original;
  const { actions } = cell.column;

  let pdfLoaderTimeout;

  const [pdfDownload, setPDFDownload] = useState(false);
  const [pdfDownloadLoading, setPDFDownloadLoading] = useState(false);

  const urlPrefix = `${window.location.protocol}//`;
  const urlSufix = '/file-ud-web/fileUD';
  // const downloadDetails = new URL(`${envConfig.fileRoot}/download_invoice`);
  const baseURL = localStorage?.getItem('apiDomain') + envConfig.fileRoot;
  const downloadDetails = new URL(`${baseURL}/download`);
  downloadDetails.search = new URLSearchParams({
    module: 'REPORT',
    details: JSON.stringify({
      inventoryId: meta.inventoryId
    })
  });

  const iconMap = {
    PDF: 'PdfFile',
    CSV: 'CsvImport',
    DEFAULTICON: 'Download'
  };

  const downloadHack = async (info) => {
    const trackReport = (trackerdata) => {
      useActivityTracker({
        event: 'DEFAULT_PDF_REPORT_DOWNLOAD_GENERATED',
        data: { reportName: reportsContext?.activeReport?.name }
      });
    };

    downloadHackHelper({
      href: downloadDetails.href,
      downloadFileName: 'nameOfFile'
    });
  };

  const pdfDownloadClick = async () => {
    setPDFDownload(true);
    setPDFDownloadLoading(true);
    const requestOptions = {
      method: 'GET',
      credentials: 'include',
      headers: getHeaderValue()
    };
    // if (pdfLoaderTimeout) clearTimeout(pdfLoaderTimeout);
    // pdfLoaderTimeout = setTimeout(() => {
    //   toast(
    //     'success',
    //     getTranslatedText(intl, 'reports.pdf.download.initiate')
    //   );
    //   setPDFDownload(false);
    // }, 1000);

    fetch(downloadDetails, requestOptions)
      .then(function(response) {
        setPDFDownloadLoading(true);
        // The response is a Response instance , parse the data into a useable format using `.json()`
        return response.json();
      })
      .then(function(data) {
        setPDFDownloadLoading(false);
        if (data?.errors) {
          toast(
            'error',
            getTranslatedText(
              intl,
              `app.errorCode.${data.errors?.[0]?.errorCode}`
            )
          );
        }
      })
      .catch((error) => {
        setPDFDownloadLoading(false);
        downloadHack(downloadDetails);
      });
  };

  if (meta?.status !== 'FAILED' && meta?.status !== 'SUCCESS') {
    return <FormattedMessage id="project.task.status.inProgress" />;
  }
  if (meta?.status === 'FAILED') {
    return <FormattedMessage id="attribute.failure" />;
  }

  return (
    <Button
      onClick={pdfDownloadClick}
      icon={<SVGIcon name={iconMap[meta?.fileType || 'DEFAULTICON']} />}
    >
      {meta?.fileType}
    </Button>
  );
}

export default injectIntl(DownloadCell);
